import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

// Maps known subdomains to their brand slugs
const SUBDOMAIN_MAP = {
  'sandwichchefs': 'sandwichchefs',
  'nenechicken': 'nenechicken',
  // Add more here as needed
};

const SubdomainRedirect = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const hostname = window.location.hostname;
    const parts = hostname.split('.');
    // e.g. sandwichchefs.cateringco.com.au → parts[0] = 'sandwichchefs'
    if (parts.length >= 4) {
      const subdomain = parts[0].toLowerCase();
      const slug = SUBDOMAIN_MAP[subdomain];
      if (slug && location.pathname === '/') {
        navigate(`/${slug}`, { replace: true });
      }
    }
  }, [navigate, location]);

  return null;
};

export default SubdomainRedirect;
